


export default {
    install(Vue, options = {}) {
        if (Vue.prototype.$buildin) {
            return
        }

        Vue.prototype.$VueFunction = Vue;

        Vue.prototype.$buildin = {
            Print: function () {
                let toHideElements;
                let cssNotPrint = ".MenuContainer , .MainMenuContainer , .PageHeaderContainer  , .BannerContainer , .PageBottomContainer , .PagePathContainer ,.LogoutButtonContainer , .Button";
                let i;

                toHideElements = document.querySelectorAll(cssNotPrint);

                for (i = 0; i < toHideElements.length; i++) {
                    toHideElements[i].style.display = "none";
                }

                window.print();

                setTimeout(
                    () => {
                         
                        toHideElements = document.querySelectorAll(cssNotPrint);

                        for (i = 0; i < toHideElements.length; i++) {
                            toHideElements[i].style.display = "";
                        }
                    }
                    ,
                    100
                );
            }
        }
         
    }
}
